import data from "../assets";
import { EAssetName } from "../interfaces/enum";

export const getLogo = (): string => {
  return getAsset(EAssetName.LOGO);
};

export const getAsset = (name: EAssetName) => {
  return data[name as keyof typeof data];
};
